<template>
	<div>
		<js-object-view-item
			:maxDepth="maxDepth"
			:data="parsed"
			:styles="customStyles"
		/>
	</div>
</template>

<script>
import JsObjectViewItem from "./JsObjectViewItem"
import { isObject } from "util"
export default {
	name: "JsObjectView",
	components: {
		JsObjectViewItem
	},
	props: {
		data: {
			required: true,
			type: Object
		},
		maxDepth: {
			type: Number,
			required: false,
			default: 1
		},
		rootKey: {
			type: String,
			required: true
		}
	},
	methods: {
		build(key, val, depth, path, includeKey) {
			if (this.isObject(val)) {
				// Build Object
				return {
					key,
					type: "object",
					depth,
					path,
					length: Object.keys(val).length,
					children: Object.keys(val)
						.filter(key => !(key === "id" || key === "entityId"))
						.map(key =>
							this.build(
								key,
								val[key],
								depth + 1,
								includeKey ? `${path}${key}.` : `${path}`,
								true
							)
						)
				}
			} else if (this.isArray(val)) {
				// Build Array

				return {
					key,
					type: "array",
					depth,
					path,
					length: val.length,
					children: val.map((child, i) =>
						this.build(
							val[i]?.type || i.toString(),
							val[i],
							depth + 1,
							includeKey ? `${path}${key}[${i}].` : `${path}`,
							false
						)
					)
				}
			} else {
				// Build Value
				return {
					key,
					type: this.getType(val),
					path: includeKey ? path + key : path.slice(0, -1),
					depth,
					value: val
				}
			}
		},
		isObject(val) {
			return (
				val === Object(val) &&
				!Array.isArray(val) &&
				!(typeof val.getMonth === "function")
			)
		},
		isArray(val) {
			return Array.isArray(val)
		},
		isString(val) {
			return typeof val === "string"
		},
		isHtml(val) {
			if (typeof val !== "string" || !val.includes("<")) return false
			var doc = new DOMParser().parseFromString(val, "text/html")
			return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
		},
		isInt(val) {
			return Number.isInteger(val)
		},
		isFloat(val) {
			return typeof value === "number" && !Number.isInteger(val)
		},
		isBoolean(val) {
			return typeof val === "boolean"
		},
		isNull(val) {
			return val === null
		},
		isDate(val) {
			return (
				typeof val === "object" &&
				val instanceof Date &&
				typeof new Date(val).getMonth === "function"
			)
		},
		getType(val) {
			if (this.isObject(val)) return "object"
			if (this.isArray(val)) return "array"
			if (this.isHtml(val)) return "htmlString"
			if (this.isString(val)) return "string"
			if (this.isInt(val)) return "number"
			if (this.isFloat(val)) return "number"
			if (this.isBoolean(val)) return "boolean"
			if (this.isNull(val)) return "null"
			return "value"
		}
	},
	computed: {
		customStyles() {
			const styles = {
				key: { color: "#002b36" },
				valueKey: { color: "#073642" },
				string: { color: "#268bd2" },
				number: { color: "#2aa198" },
				boolean: { color: "#cb4b16" },
				null: { color: "#6c71c4" }
			}
			return styles
		},
		parsed() {
			return this.build(this.rootKey, { ...this.data }, 0, "", true)
		},
		type() {
			if (Array.isArray(this.data)) return "array"
			if (this.data === Object(this.data)) return "object"
			return "string"
		}
	}
}
</script>

<style></style>
